module.exports = {"370285001":"水集街道","370285002":"望城街道","370285007":"沽河街道","370285101":"姜山镇","370285102":"夏格庄镇","370285104":"院上镇","370285105":"日庄镇","370285106":"南墅镇","370285107":"河头店镇","370285108":"店埠镇","370285116":"马连庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370285.json
// module id = 1269
// module chunks = 0